// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Camera } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconCamera(props: any) {
    return <IconBase icon={Camera} {...props} />
  }

  export default IconCamera
  